import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { SearchProvider } from './context/SearchContext';
import Layout from './components/Layout';
import Home from './pages/Home/Home';
import ProtectedRoute from './components/ProtectedRouteHome';
import Login from './pages/Login/login';
import AllDepartments from './pages/AllDepartments/AllDepartments';
import DepartmentCourses from './pages/DepartmentCourses/DepartmentCourses';
import CourseVideos from './pages/Coursevideo/CourseVideos';
import SearchResults from './pages/SearchResults/SearchResults';
import Profile from './pages/UserProfile/Profile';
import MyCourses from './pages/MyCourses/MyCourses';
import MyLearningPath from './pages/MyCourses/MyLearningPath';
import MyTrainingVideos from './pages/MyCourses/MyTrainingVideos';
import Certificates from './pages/Certificates/Certificates';
import Feedback from './pages/Feedbacks/Feedback';
import HelpCenter from './pages/HelpCenter/HelpCenter';
import ManageLearningPaths from './pages/ManageLearningPaths/ManageLearningPaths';
import LearningPathLayout from './pages/ManageLearningPaths/LearningPathLayout';
import LearningPathDetail from './pages/MyCourses/LearningPathDetail.js';
import Overview from './pages/ManageLearningPaths/Overview';
import Courses from './pages/ManageLearningPaths/Courses';
import Users from './pages/ManageLearningPaths/Users';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import { AuthProvider } from './components/AuthContext';
import Admin from './pages/Admin/admin';
import Dashboard from './pages/Admin/dashboard';
import AdminCourses from './pages/Admin/courses';
import Tests from './pages/Admin/test';
import Roles from './pages/Admin/roles';
import CourseNavigationLayout from './pages/MyCourses/CourseNavigationLayout';
import ApproveCertificates from './pages/Admin/ApproveCertificates';
import TrainingVideoPlayer from './pages/TrainingVideoPlayer/TrainingVideoPlayer';
import ScormManagement from './pages/Admin/ScormManagement';
import ScormCourses from './pages/ScormCourses/ScormCourses';
import ScormPlayer from './pages/ScormCourses/ScormPlayer';

import APIDocumentation from './pages/APIDocumentation/APIDocumentation';
import ProtectedManagerRoute from './components/ProtectedManagerRoute';
import AuthCallback from './pages/Login/AuthCallback';
// Separate component for pages that should use the Layout
function AppContent() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function App() {
  return (
    <SearchProvider>
      <AuthProvider>
      <Router>
        <Routes>
          {/* Routes outside the Layout */}
          <Route path="/Login" element={<Login />} />
          <Route path="lndapidocumentation" element={<APIDocumentation />} />

          {/* Routes inside the Layout */}
          <Route path="/" element={<AppContent />}>
            <Route index element={<Navigate to="/Login" />} />
<Route 
  path="Home" 
  element={
    <ProtectedRoute>
      <Home />
    </ProtectedRoute>
  } 
/>

            <Route path="departments" element={<AllDepartments />} />
            <Route path="departments/:departmentName" element={<DepartmentCourses />} />
            <Route path="my-courses" element={<CourseNavigationLayout />}>
              <Route index element={<Navigate to="mycourses" replace />} />
              <Route path="mycourses" element={<MyCourses />} />
              <Route path="mylearningpath">
                <Route index element={<MyLearningPath />} />
                <Route path="learningpathdetail/:learning_path_id" element={<LearningPathDetail />} />
              </Route>
              <Route path="trainingvideos" element={<MyTrainingVideos />} />
            </Route>
            <Route path="certificates" element={<Certificates />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="course-videos" element={<CourseVideos />} />
            <Route path=":departmentName/:videoId/training-videos" element={<TrainingVideoPlayer />} />
            <Route path="search-results" element={<SearchResults />} />
            <Route path="profile" element={<Profile />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/help-center" element={<HelpCenter />} />
            <Route path="scorm" element={<ScormCourses />} />
            <Route path="scorm/player/:courseId" element={<ScormPlayer />} />
            <Route path="admin" element={<ProtectedAdminRoute />}>
              <Route element={<Admin />}>
                <Route index element={<Navigate to="dashboard" />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="courses" element={<AdminCourses />} />
                <Route path="scorm" element={<ScormManagement />} />
                <Route path="tests" element={<Tests />} />
                <Route path="roles" element={<Roles />} />
                <Route path="approve-certifications" element={<ApproveCertificates />} />
              </Route>
            </Route>
            <Route element={<ProtectedManagerRoute />}>
              <Route path="/manage-learning-paths" element={<ManageLearningPaths />} />
              <Route path="/manage-learning-paths/:name" element={<LearningPathLayout />}>
                <Route path="overview" element={<Overview />} />
                <Route path="courses" element={<Courses />} />
                <Route path="users" element={<Users />} />
                <Route index element={<Navigate to="overview" />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </Router>
      </AuthProvider>
    </SearchProvider>
  );
}

export default App;